import Phaser from 'phaser';
import gameData from '../../gameData';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../../UIAssetKeys';
import AScene from '../../library/ExtendedObjects/AScene';
import Machine from '../game/Machine';
import Intro from '../intro/Intro';

export default class TestSentenceScene extends AScene {
  static get KEY() { return 'TestSentenceScene'; }

  constructor() {
    super({ key: (TestSentenceScene).KEY });
  }

  create() {
    this.add.rectangle(0,0,this.scale.width, this.scale.height, 0x444444).setOrigin(0);
    this.sound.stopAll();

    this.delay = 250;
    this.machine = this.addContainer(this.mid.x, -100, new Machine(this, false));
    this.machine.showPortal();
    this.machine.on("SENTENCE", (sentence, lines)=>{
      if(lines > 3){
        console.warn("Has more than 3 lines: " + sentence);
        this.delay = 1000;
      } else {
        this.delay = 250;
      }
    })

    this.homeBtn = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._ExitBtn, this).setInteractive().once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, ()=>{
      this.scene.stop();
      this.scene.resume(Intro.KEY);
    });
    this.homeBtn.setPosition(this.scale.width-this.homeBtn.width * 0.6, this.scale.height-this.homeBtn.height * 0.6);

    this.time.delayedCall(this.delay, ()=>{this.checkSentences();});
  }

  async checkSentences() {
    for(let i = 0; i < gameData.sentences.length; i++) {
      this.machine.clearSentence();
      
      await new Promise((resolve) => this.time.delayedCall(this.delay, resolve));
    }
  }
}